module.exports = __webpack_public_path__ + "img/room_qrcode.e458a72e.png";